<template>
  <div v-if="showCookie" class="cookie-overlay">
    <div v-if="!showCustomCookie" class="cookie-banner">
      <div class="row">
        <div class="col-md-7 d-md-flex align-items-center">
          <img src="../assets/images/home/cookie.png" width="60px" height="60px"/>
          <div class="text-start ms-4">
            We use cookies to enhance your experience on our site. Some cookies are essential for site 
            functionality, while others help us improve performance, personalize your experience, and 
            deliver relevant advertising. You can manage your 
            <span @click="showCustomCookie=true" style="color: var(--tm-accent);text-decoration:underline;cursor: pointer;">
              Cookie Preferences
            </span>.
          </div>
        </div>
        <div class="col-md-5 row align-items-center">
          <div class="col-xl-5 px-0 mx-0 mt-xl-0 mt-2"><button class="btn1" @click="setCookie('all')">Accept All Cookies</button></div>
          <div class="col-xl-7 mt-xl-0 mt-2 px-0 mx-0"><button class="btn2" @click="setCookie('reject_non_essential')">Reject Non-Essential Cookies</button></div>
        </div>
      </div>
    </div>
    <div v-if="showCustomCookie" class="cookie-banner2">
      <div class="row">
        <div class="align-items-center">
          <div class="text-start ms-4">
            <h5><strong>Manage Cookies</strong></h5>
            We use cookies to ensure our website works efficiently, to analyze how users interact with our site, and to personalize your experience. Below, you can choose which cookies to allow. For more details, see our Cookie Policy. 
            <br>
            <br>
            Your permission applies to the following domains:
            <br>
            <ul>
              <li>Topment.fr</li>
            </ul>
            <div class="card-switch">
              <div>
                <h6><strong>Essential Cookies</strong></h6>
                <div class="row form-check form-switch d-flex px-0 align-items-center">
                  <div class="col-sm-10 fs-6">
                    These cookies are necessary for the operation of our website and cannot be disabled. They are used for functions like security, network management, and accessibility.
                  </div>
                  <div class="col-sm-2 text-end">
                    <input class="form-check-input ms-0 fs-5" type="checkbox" role="switch" disabled v-model="essential">
                  </div>
                </div>
              </div>
              <hr>
              <div>
                <h6><strong>Statistic (Mandatory)</strong></h6>
                <div class="row form-check form-switch d-flex px-0 align-items-center">
                  <div class="col-sm-10 fs-6">
                    Statistic cookies help website owners to understand how visitors interact with websitesby collecting and reporting information anonymously.
                  </div>
                  <div class="col-sm-2 text-end">
                    <input class="form-check-input ms-0 fs-5" type="checkbox" role="switch" disabled v-model="statistic">
                  </div>
                </div>
              </div>
              <hr>
              <div>
                <h6><strong>Performance and Analytics Cookies (Optional)</strong></h6>
                <div class="row form-check form-switch d-flex px-0 align-items-center">
                  <div class="col-sm-10 fs-6">
                    These cookies help us understand how visitors interact with our website by collecting and reporting information anonymously, like cookies for Google Analytics, and cookies to remember your preferences (like language and region) to enhance your user experience.
                  </div>
                  <div class="col-sm-2 text-end">
                    <input class="form-check-input ms-0 fs-5" type="checkbox" role="switch" v-model="performance">
                  </div>
                </div>
              </div>
              <hr>
              <div>
                <h6><strong>Targeting and Advertising Cookies (Optional)</strong></h6>
                <div class="row form-check form-switch d-flex px-0 align-items-center">
                  <div class="col-sm-10 fs-6">
                    These cookies are used to deliver personalized advertisements based on your interests and browsing history. They may also track your activity across other websites.
                  </div>
                  <div class="col-sm-2 text-end">
                    <input class="form-check-input ms-0 fs-5" type="checkbox" role="switch" v-model="optional">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="align-items-center text-end">
          <span class="mx-2 mt-3 cursor-pointer" style="color: var(--tm-ink);text-decoration: underline;" @click="showCustomCookie=false"><strong>back</strong></span>
          <button class="btn2 mt-3" @click="customCookei()">Save Preferences</button>
          <button class="btn1 mx-2 mt-3" @click="setCookie('all')">Accept All Cookies</button>
        </div>
        <div class="mt-3 mx-2 text-start">
          You can update your preferences at any time by returning to this page. Alternatively, you can manage cookies via your browser settings.
        </div>
      </div>
    </div>
  </div>
</template>
  
<script>
import { defineComponent, onMounted, ref } from 'vue';

export default defineComponent({
  setup(){
    const showCustomCookie = ref(false)
    const showCookie = ref(false)
    const optional = ref(false)
    const performance  = ref(false)
    const statistic = ref(true)
    const essential = ref(true)

    function setCookie(params) {
      let list = [];
      list.push(params);
      localStorage.setItem('cookieConsent',list);
      showCookie.value = false;
    }

    onMounted(()=>{
      if (!localStorage.getItem("cookieConsent")) {
        showCookie.value = true;
      }
    })

    function customCookei() {
      let list = [];
      if (optional.value) {
        list.push('optional')
      }
      if(performance.value){
        list.push('performance')
      }
      if(statistic.value){
        list.push('statistic')
      }
      if(essential.value){
        list.push('essential')
      }
      localStorage.setItem('cookieConsent',list);
      showCookie.value = false;   
    }

    return {
      showCustomCookie,
      optional,
      performance,
      statistic,
      essential,
      showCookie,
      customCookei,
      setCookie
    }
  }
    
});
</script>
<style lang="scss">
.cookie-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100dvh;
  background: rgba(11, 34, 57, 0.4);
  z-index: 9999; /* بالاترین مقدار برای قرارگیری روی سایر عناصر */
  display: flex;
  align-items: center;
  justify-content: center;
}

.cookie-banner {
  position: fixed;
  bottom: 2%;
  left: 5%;
  background-color: var(--tm-surface);
  border: 1px solid var(--tm-border);
  border-radius: var(--tm-radius-md);
  box-shadow: var(--tm-shadow-lg);
  color: var(--tm-ink-muted);
  width: 90%;
  padding: 15px;
  text-align: center;
  z-index: 5;
}

.cookie-banner2 {
  position: fixed;
  bottom: 2%;
  left: 25%;
  background-color: var(--tm-surface);
  border: 1px solid var(--tm-border);
  border-radius: var(--tm-radius-md);
  box-shadow: var(--tm-shadow-lg);
  color: var(--tm-ink-muted);
  width: 50%;
  padding: 15px;
  text-align: center;
  z-index: 5;
  height: 90vh;
  overflow-x: hidden;
  overflow-y: scroll;
  @media(max-width:800px){
    width: 90%;
    left: 5%;
  }
}

.btn1 {
  background-color: var(--tm-accent);
  border: none;
  border-radius: var(--tm-radius-sm);
  padding: 9px 18px;
  font-weight: 600;
  color: #fff;
  transition: background-color 0.15s ease, transform 0.1s ease;
}

.btn1:hover {
  background-color: var(--tm-accent-deep);
}

.btn1:active {
  transform: scale(0.98);
}

.btn2 {
  background-color: var(--tm-surface);
  border: 1px solid var(--tm-border);
  border-radius: var(--tm-radius-sm);
  padding: 9px 18px;
  color: var(--tm-ink);
  font-weight: 600;
  transition: background-color 0.15s ease, transform 0.1s ease;
}

.btn2:hover {
  background-color: rgba(47, 74, 96, 0.08);
}

.btn2:active {
  transform: scale(0.98);
}

.card-switch {
  border: 1px solid var(--tm-border-strong);
  border-radius: var(--tm-radius-sm);
  padding: 15px;
}
</style>  